// @flow
import React from 'react'
import ErrorTemplate from 'components/templates/ErrorTemplate'
import { connect } from 'react-redux'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { viewerFragment } from 'common/fragments'
import Path from 'routes/path'
import { imagePath } from 'frontend_core/dist/helpers/image'

function ErrorContainer(props) {
  const title = i18n.t(`error.${props.status}.title` || 'error.default.title')
  const description =
    i18n.t(`error.${props.status}.description`) ||
    i18n.t('error.default.description')
  return (
    <ErrorTemplate {...props}>
      <div className="error">
        <div className="error__main page__stripes">
          <img
            src={imagePath('www/error/error_main-visual.png')}
            className="error__main-visual"
            role="presentation"
          />
          <h1 className="error__title">{title}</h1>
          <p className="error__message">{description}</p>
          <a href={Path.home()} className="button-blue error__button">
            {i18n.t('page.error.buttonToTop')}
          </a>
        </div>
      </div>
    </ErrorTemplate>
  )
}
const withData = graphql(
  gql`{
  viewer {
    ${viewerFragment}
  }
}`,
  { options: { notifyOnNetworkStatusChange: true } },
)(ErrorContainer)

function mapStateToProps(state) {
  return state
}
export default connect(mapStateToProps)(withData)



// WEBPACK FOOTER //
// ./src/containers/pages/ErrorPage.jsx